import { PARAMETERS_PARAM_TYPES } from 'Common/enums';
import { ParameterType } from 'Common/parameterEnums';
import _ from 'lodash';
import { MAX_NEW_CONDITIONS } from 'Utils';

// Return an array of operator conditions

// TODO: Once BE pipeline fully supports strin and strnotin operators
// remove the operators from non-templated rules
// disable them for templated-rules

// TODO: Remove the parameterType check when the runtime supports strinlist and strnotinlist
// for system_expression type parameters

const allowListOperators = (parameterType?: string): boolean => {
    if (parameterType === ParameterType.SYSTEM) {
        return true;
    }
    return false;
};

export const getOperatorOptions = (type: string, parameterType?: string) => {
    switch (type) {
        case PARAMETERS_PARAM_TYPES.STRING:
            return allowListOperators(parameterType)
                ? ['eq', 'neq', 'strinlist', 'strnotinlist', 'strcontains', 'strnotcontains']
                : ['eq', 'neq', 'strcontains', 'strnotcontains'];
        case PARAMETERS_PARAM_TYPES.CURRENCY:
            return ['eq', 'neq', 'gt', 'lt', 'ge', 'le'];
        case PARAMETERS_PARAM_TYPES.NUMBER:
            return allowListOperators(parameterType)
                ? ['eq', 'neq', 'gt', 'lt', 'ge', 'le', 'strinlist', 'strnotinlist']
                : ['eq', 'neq', 'gt', 'lt', 'ge', 'le'];
        case PARAMETERS_PARAM_TYPES.PAN:
            return allowListOperators(parameterType) ? ['strinlist', 'strnotinlist'] : [];
        default:
            return allowListOperators(parameterType)
                ? ['eq', 'neq', 'gt', 'lt', 'ge', 'le', 'strinlist', 'strnotinlist', 'strcontains', 'strnotcontains']
                : ['eq', 'neq', 'gt', 'lt', 'ge', 'le', 'strcontains', 'strnotcontains'];
    }
};

export const getValueByParamType = (value: string[], operatorField: string, paramType: string) => {
    switch (paramType) {
        case PARAMETERS_PARAM_TYPES.STRING:
        case PARAMETERS_PARAM_TYPES.NUMBER:
        case PARAMETERS_PARAM_TYPES.CURRENCY:
            if (operatorField === 'strinlist' || operatorField === 'strnotinlist') {
                return value;
            }
            return value[0];
        case PARAMETERS_PARAM_TYPES.PAN:
            return value;
        default:
            return value[0];
    }
};

// Return the error object of nested form values for the given parameter at the given index
export const getErrorByParameter = (
    formikErrors: any,
    formikTouched: any,
    key: string,
    parameter: string,
    index: number
) => {
    return Array.isArray(formikErrors?.[key]) &&
        Array.isArray(formikTouched?.[key]) &&
        formikErrors[key]?.[index]?.[parameter] &&
        formikTouched[key]?.[index]?.[parameter]
        ? !!(formikErrors[key][index][parameter] && formikTouched[key][index][parameter])
        : undefined;
};

// Return the error message of nested form values for the given parameter at the given index
export const getErrorMsgByParameter = (formikErrors: any, key: string, parameter: string, index: number) => {
    return Array.isArray(formikErrors[key]) && formikErrors[key]?.[index]?.[parameter]
        ? (formikErrors[key][index][parameter] as string)
        : undefined;
};

export const isConditionFilled = (customCondition: CustomConditionObj) => {
    return (
        !_.isEmpty(String(customCondition?.parameterField)) &&
        !_.isEmpty(String(customCondition?.operatorField)) &&
        !_.isEmpty(String(customCondition?.valueField))
    );
};

export const isAllConditionsFilled = (customConditions: CustomConditions) => {
    return (
        customConditions.filter((condition, index) => !isConditionFilled(condition) && index < MAX_NEW_CONDITIONS)
            .length < 1
    );
};
